import script from "./ShowHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./ShowHeader.vue?vue&type=script&setup=true&lang=ts"

import "./ShowHeader.vue?vue&type=style&index=0&id=1e534960&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e534960"]])

export default __exports__